import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from './components/Hero';
import WhatYouLearn from './components/WhatYouLearn';
import CourseContent from './components/CourseContent';
import WhyAI from './components/WhyAI';
import Bonuses from './components/Bonuses';
import TargetAudience from './components/TargetAudience';
import Results from './components/Results';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function SellMoreWorkshop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <main>
        <Hero />
        <WhatYouLearn />
        <CourseContent />
        <WhyAI />
        <Bonuses />
        <TargetAudience />
        <Results />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}